<template>
    <transition name="jmv-toast-pop">
        <div class="jmv-toast" :class="custom ? custom + ' ' + pos : 'default ' + pos" v-show="visible">
            <div class="jmv-toast-icon" v-show="type != 'text'">
                <slot name="icon"><i></i></slot>
            </div>
            <p class="jmv-toast-content">{{text}}</p>
        </div>
    </transition>
</template>
<script>
    export default {
        props: {
            custom: String,    // 是否自定义样式
            text: String,
            type: {
                type: String,
                default: "text"
            },
            pos: {
                type: String,
                default: "middle"
            },
            time: {
                type: Number,
                default: 1
            },
            autoClose: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                timer: null,
                visible: false
            }
        },
        created () {
//            if(this.autoClose) {
//                clearTimeout(this.timer);
//                this.timer = setTimeout(() => this.$emit("disappear"),this.time * 1000);
//            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .jmv-toast.default {
        position: fixed; z-index: 600; left: 50%; padding: 10px; font-size: 16px; background-color: rgba(0,0,0,0.7); text-align: center; color: #ffffff; border-radius: 5px;
        transition: opacity .3s linear;
        .jmv-toast-icon {margin-bottom: 10px;
            i { margin: 0 auto;  width: 32px; height: 32px; display: block; background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAAVFBMVEXx8fHMzMzr6+vn5+fv7+/t7e3d3d2+vr7W1tbHx8eysrKdnZ3p6enk5OTR0dG7u7u3t7ejo6PY2Njh4eHf39/T09PExMSvr6+goKCqqqqnp6e4uLgcLY/OAAAAnklEQVRIx+3RSRLDIAxE0QYhAbGZPNu5/z0zrXHiqiz5W72FqhqtVuuXAl3iOV7iPV/iSsAqZa9BS7YOmMXnNNX4TWGxRMn3R6SxRNgy0bzXOW8EBO8SAClsPdB3psqlvG+Lw7ONXg/pTld52BjgSSkA3PV2OOemjIDcZQWgVvONw60q7sIpR38EnHPSMDQ4MjDjLPozhAkGrVbr/z0ANjAF4AcbXmYAAAAASUVORK5CYII=") no-repeat center center; background-size: cover;}
        }
        .jmv-toast-content { line-height: 1.5;}
    }
    .jmv-toast.default.top { top: 0; transform: translate3d(-50%,30px,0)}
    .jmv-toast.default.middle { top: 50%; transform: translate3d(-50%,-50%,0);}
    .jmv-toast.default.bottom { bottom: 0; transform: translate3d(-50%,-30px,0)}
    .jmv-toast-pop-enter, .jmv-toast-pop-leave-active {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue